export default "__VITE_ASSET__9bcd2ab4__"